module.exports = __webpack_public_path__ + "img/sjkb@2x.b80e6674.png";